import script from "./NewsPage.vue?vue&type=script&setup=true&lang=js"
export * from "./NewsPage.vue?vue&type=script&setup=true&lang=js"

import "../styles/news.css?vue&type=style&index=0&lang=css&external"

const __exports__ = script;

export default __exports__